const setCell = (state, data) => {
    state.cell = data;
}


const setCoordinates = (state, content) => {
    state.coordinates = content;
    // O eixo maior ocupa 400 px e o outro é proporcional. A escala (px por µm) precisa ser a
    // mesma nos dois eixos: com escalas diferentes, células não quadradas ficavam com o y
    // convertido errado e os círculos distorcidos.
    const axisX = Number(state.coordinates.x);
    const axisY = Number(state.coordinates.y);
    const scale = 400 / Math.max(axisX, axisY);
    const width = axisX * scale;
    const height = axisY * scale;
    const relationship = { x: scale, y: scale, z: scale };

    state.dimensions = {
        width,
        height,
        relationship
    }
}

const setPMLThickness = (state, content) => {
    state.pml.thickness = content;
}

const setTitle = (state, content) => {
    state.title = content;
}

const setDescription = (state, content) => {
    state.description = content;
}

const setResolution = (state, content) => {
    state.resolution = content;
}

// O Meep usa "until" da raiz do payload (e só cai em plotOptions.until se ela faltar):
// os dois precisam mudar juntos, senão o tempo digitado no painel era ignorado
const setUntil = (state, content) => {
    state.until = Number(content);
    state.plotOptions.until = Number(content);
}

const setViewSimulation = (state, content) => {
    state.view_simulation = content;
}

const setSceneSimulation = (state, content) => {
    state.scene_simulation = content;
}
export {
    setCell,
    setCoordinates,
    setPMLThickness,
    setTitle,
    setDescription,
    setResolution,
    setUntil,
    setViewSimulation,
    setSceneSimulation,
}
